import { createDynamicSlice } from ".";
import { fetchProcessesThunk } from "../thunks/processesThunk";

export const processesSlice = createDynamicSlice({
  name: "processes",
  thunk: fetchProcessesThunk,
  listMode: true,
  resetActionName: "resetProcesses",
});

export const processesReducer = processesSlice.reducer;
export const { resetProcesses } = processesSlice.actions;
